export default __webpack_public_path__ + "static/media/body-side.1b63ed22.png";